import React from 'react';
import { ColorMode, LUXProvider } from '@lux/core';

interface LUXProviderWrapperProps {
    children: React.ReactNode;
}

export const LUXProviderWrapper = ({ children }: LUXProviderWrapperProps) => {
    return (
        <LUXProvider
            initialColorMode={
                window.WEBVIEW_THEME === ColorMode.DARK ? ColorMode.DARK : ColorMode.LIGHT
            }
            isRootLevel
        >
            {children}
        </LUXProvider>
    );
};
